import Vue from "vue";
import msgbox from "@/plugins/message-box";
Vue.use(msgbox);

import $localStorage from "@/utils/localStorage";
import { memberData } from "@/interface/member";
import { MessageBoxImageType, CanteenDailyShowBindPhone,IsDesk } from "@/constants/index";

export default {
	methods: {
        checkPhone() {
            
            return new Promise((resolve, reject) => {
				let isDesk = $localStorage.get(IsDesk);
				if(isDesk){
					resolve();
					return ;
                }
                let memberInfo = $localStorage.get("memberInfo");
                
				if (!memberInfo) {
					memberData({
						user_id: this.$root.user_id
                    }).then(data => {
						if (!data.result.phone) {
							this.showBindPhoneBox(resolve, reject);
						} else {
							resolve();
						}
						$localStorage.set("memberInfo", data.result);
					});
                } else {
					if (!memberInfo.phone) {
						this.showBindPhoneBox(resolve, reject);
					} else {
						resolve();
					}
                }
			});
		},
        showBindPhoneBox(resolve, reject) {
			if (this.$root.type == "package") {
				this.$msgbox.show({
					imageType: MessageBoxImageType.ImgPackageBindPhone,
					showCancelBtn: true,
					messageText: "绑定手机号才能订餐，并且有机会获得优惠券，是否现在绑定?",
					cancelBtnText: "我再想想",
					confirmBtnText: "立即绑定",
					confirmFn: () => {
						window.location.href = `./bindPhone.html`;
					}
				});
            } else if (this.$root.type == "personal") {
                resolve();
             } else if (this.$root.type == "canteen") {
				let now = new Date(),
					dailyShow = $localStorage.get(CanteenDailyShowBindPhone);
				if (dailyShow && (dailyShow.endTime > now.getTime())) {
					resolve();
				} else {
					// 明天凌晨 0:00
					let endTime = now.setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000;
					$localStorage.get(CanteenDailyShowBindPhone,{endTime});
					this.$msgbox.show({
						imageType: MessageBoxImageType.ImgCanteenBindPhone,
						showCancelBtn: true,
						messageText: "绑定手机号就有机会获得优惠券，是否现在绑定",
						cancelBtnText: "直接订餐",
						confirmBtnText: "立即绑定",
						cancelFn: () => {
							resolve();
						},
						confirmFn: () => {
							window.location.href = `./bindPhone.html`;
						}
					});
				}
			}
		}
	}
};
